import { Card, CardContent, Typography } from "@mui/material";

const StepCard = ({ step, title, description, icon }) => {
  return (
    <Card
      sx={{
        p: 1,
        boxShadow: "none",
        border: "1px solid #dfc4b6ff",
        borderRadius: 3,
        textAlign: "center",
        // width: "260px", // 300px
        // width: { xs: 320, sm: 335, md: "100%" },
        width: { xs: 320, sm: 335, md: 260 },
      }}
    >
      <CardContent>
        {icon}

        <Typography
          variant="subtitle2"
          color="text.secondary"
          mt={2}
          sx={{ fontFamily: '"Poppins", serif' }}
        >
          STEP {step}
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontFamily: '"Poppins", serif', fontSize: "1.1rem" }}
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontFamily: '"Poppins", serif' }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StepCard;
